import movieapp from "./movieappmockup.png";
import mysheets from "./mysheetsmockup.png";
import stockhunt from "./stockhuntmockup.png";

const MOCKUPS = [movieapp, mysheets, stockhunt];

export default MOCKUPS;
